import { render, staticRenderFns } from "./FormDocumentations.vue?vue&type=template&id=56ba25f6"
import script from "./FormDocumentations.vue?vue&type=script&lang=js"
export * from "./FormDocumentations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports